import React from 'react';
import Icon, { IconProps } from './Icon';

// shield-tick *
const SafetyCertificateOutlinedSvg: React.FC<React.SVGProps<SVGSVGElement>> = (
    props
) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9 11.4984L11 13.4984L15.5 8.99841M20 11.9984C20 16.9068 14.646 20.4768 12.698 21.6133C12.4766 21.7424 12.3659 21.807 12.2097 21.8405C12.0884 21.8665 11.9116 21.8665 11.7903 21.8405C11.6341 21.807 11.5234 21.7424 11.302 21.6133C9.35396 20.4768 4 16.9068 4 11.9984V7.21601C4 6.4165 4 6.01674 4.13076 5.67311C4.24627 5.36955 4.43398 5.09868 4.67766 4.88394C4.9535 4.64084 5.3278 4.50048 6.0764 4.21975L11.4382 2.20908C11.6461 2.13112 11.75 2.09214 11.857 2.07669C11.9518 2.06298 12.0482 2.06298 12.143 2.07669C12.25 2.09214 12.3539 2.13112 12.5618 2.20908L17.9236 4.21975C18.6722 4.50048 19.0465 4.64084 19.3223 4.88394C19.566 5.09868 19.7537 5.36955 19.8692 5.67311C20 6.01674 20 6.4165 20 7.21601V11.9984Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const SafetyCertificateOutlined: React.FC<Omit<IconProps, 'component'>> = (props) => (
    <Icon
        component={SafetyCertificateOutlinedSvg}
        className="s9sicon-safety-certificate"
        {...props}
    />
);
export default SafetyCertificateOutlined;
